// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%273.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><path d=%27M5 12h14M13 6l6 6-6 6%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   MIS REPORT
========================================================= */

.mis-container {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.mis-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 14px 0;
  font-size: 14px;
  font-weight: 800;
  color: #151515;
}

/* =========================================================
   FILTER BAR (dark blue, white labels, white rounded selects)
========================================================= */

.mis-filter-section {
  width: 100%;
  min-height: 86px;
  margin: 0 0 0px 0;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: none;
  border-radius: 0;
  overflow: visible;
  background: linear-gradient(
    180deg,
    #005394 0%,
    #00579a 50%,
    #0a67b0 80%,
    #1a7fcb 100%
  );
}

.mis-filter-row {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  align-items: center;
}

.mis-filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.mis-filter-group label {
  flex: 0 0 auto;
  margin: 0;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
}

/* react-select wrapper takes the remaining width */
.mis-filter-group > div {
  flex: 1 1 auto;
  min-width: 0;
}

.mis-select__control {
  min-height: 38px !important;
  height: 38px !important;
  border: 1px solid #d9e6f4 !important;
  border-radius: 10px !important;
  background: #fff !important;
  box-shadow: none !important;
  cursor: pointer;
}

.mis-select__control--is-focused {
  border-color: #7fb8f0 !important;
  box-shadow: 0 0 0 2px rgba(127, 184, 240, 0.45) !important;
}

.mis-select__value-container {
  padding: 0 10px !important;
  flex-wrap: nowrap !important;
  overflow: hidden;
}

.mis-select__placeholder,
.mis-select__single-value {
  font-size: 11px !important;
  color: #222 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.mis-select__input-container {
  margin: 0 !important;
  padding: 0 !important;
}

.mis-select__indicators {
  height: 36px !important;
}

.mis-select__indicator {
  padding: 6px !important;
  color: #111 !important;
}

.mis-select__indicator-separator {
  display: none !important;
}

.mis-select__menu {
  z-index: 20 !important;
  font-size: 12px !important;
}

/* =========================================================
   CARDS  (works with the ORIGINAL markup:
   .mis-card > .mis-card-icon + .mis-card-content + .metric-arrow)
   Default 8 cards: 4 columns. 9 cards (Budget): centered 3 columns.
========================================================= */

.mis-card-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  margin: 0;
  padding: 20px;
  background: #ffffff;
  border-radius: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .12);

  box-sizing: border-box;
}

/* Budget has 9 cards -> 3 columns, centered (no JSX change needed) */
.mis-card-wrapper:has(.mis-card:nth-child(9)) {
  grid-template-columns: repeat(3, 223px);
  justify-content: center;
}

.mis-card {
  --c: #1f5fae;
  --v: var(--c);
  --bg: #f1f4f9;

  min-width: 0;
  height: 135px;
  padding: 14px 20px 14px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto 1fr auto;
  background: var(--bg);
  border: 1px solid var(--c);
  border-radius: 16px;
  overflow: hidden;
}

.mis-card-icon {
  grid-column: 1;
  grid-row: 1;
  width: 42px;
  height: 42px;
  color: var(--c);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mis-card-icon img {
  width: 42px;
  height: 42px;
  object-fit: contain;
  /* bolder look: stronger colour + slight outline thickening */
  filter: saturate(1.5) contrast(1.25) brightness(0.92)
    drop-shadow(0 0 0.6px currentColor);
}

/* arrow: image hidden, circle + arrow drawn in the card colour */
.mis-card .metric-arrow {
  grid-column: 2;
  grid-row: 1;
  align-self: start;
  position: relative;
  width: 22px;
  height: 22px;
  margin: 0;
  box-sizing: border-box;
  background: #ffffff;
  border: 1.5px solid var(--c);
  border-radius: 50%;
  cursor: pointer;
}

.mis-card .metric-arrow-img {
  display: none;
}

.mis-card .metric-arrow::after {
  content: "";
  position: absolute;
  inset: 0;
  background-color: var(--c);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / 11px 11px no-repeat;
}

.mis-card-content {
  grid-column: 1 / -1;
  grid-row: 2;
  align-self: end;
  min-width: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mis-card-content h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  color: #111;
}

.mis-card-content h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--v);
}

/* progress-style bar at the bottom */
.mis-card::after {
  content: "";
  grid-column: 1 / -1;
  grid-row: 3;
  height: 4px;
  margin-top: 8px;
  border-radius: 2px;
  background: linear-gradient(
    to right,
    var(--c) 0,
    var(--c) 76%,
    #c4c4c4 76%,
    #c4c4c4 100%
  );
}

.mis-card:nth-child(1) { --c: #1f5fae; --v: #3b8fd9; --bg: #f1f4f9; }
.mis-card:nth-child(2) { --c: #7b3f9e; --bg: #f7f2fa; }
.mis-card:nth-child(3) { --c: #c8203c; --bg: #f8e6e9; }
.mis-card:nth-child(4) { --c: #d4731f; --bg: #fcf9f0; }
.mis-card:nth-child(5) { --c: #0f9e8c; --bg: #edfcff; }
.mis-card:nth-child(6) { --c: #2b3a94; --bg: #e6ebfa; }
.mis-card:nth-child(7) { --c: #1f8a5a; --bg: #e9f6ef; }
.mis-card:nth-child(8) { --c: #6b4423; --bg: #fcf5ee; }
.mis-card:nth-child(9) { --c: #c0397a; --bg: #fdeef5; }

/* =========================================================
   DETAIL TABLE SCREENS (all tables share this look)
   faint panel  >  header row  >  white card (table + pagination)
   Selectors are scoped under .mis-container so they beat innercss.css
   regardless of import order.
========================================================= */

.mis-container .mis-table-card {
  --panel: #edf0f6;
  --th: #2f7bd9;
  --row: #e6f1fb;
  --line: #b9d6f2;

  width: 100%;
  box-sizing: border-box;
  background: var(--panel) !important;
  border-radius: 14px;
  padding: 14px 14px 16px;
}

/* ---------- header row (back button, title, search) ---------- */

.mis-container .mis-table-card > div:first-child {
  margin-bottom: 14px !important;
}

.mis-container .mis-table-card > div:first-child button {
  width: 36px;
  height: 36px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff !important;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(20, 40, 100, 0.12);
}

.mis-container .mis-table-card > div:first-child button img {
  width: 26px !important;
  height: 26px !important;
  object-fit: contain;
}

.mis-container .mis-table-card h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111;
}

.mis-container .mis-table-card input[type="text"] {
  height: 36px !important;
  background: #ffffff !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(20, 40, 100, 0.06);
  font-size: 12px !important;
  outline: none;
}

/* ---------- white card: table part ---------- */

.mis-container .mis-table-card > .mis-table-wrap {
  margin: 0;
  padding: 14px 14px 0;
  background: #ffffff !important;
  border-radius: 4px 4px 0 0;
  overflow-x: auto;
  box-sizing: border-box;
}

.mis-container .mis-table-card .mis-table {
  width: 100%;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  table-layout: auto;
  border: 1px solid var(--line) !important;
  border-radius: 4px;
  overflow: hidden;
  background: var(--row) !important;
}

/* neutralise global tr / thead / tbody rules from innercss.css */
.mis-container .mis-table-card .mis-table tr {
  border: none !important;
  font-size: inherit !important;
  background: transparent;
}

.mis-container .mis-table-card .mis-table thead,
.mis-container .mis-table-card .mis-table tbody {
  text-align: center;
  border: none !important;
}

.mis-container .mis-table-card .mis-table thead th {
  padding: 11px 10px;
  background: var(--th) !important;
  color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  border: none !important;
  border-right: 1px solid rgba(255, 255, 255, 0.55) !important;
}

.mis-container .mis-table-card .mis-table thead th:last-child {
  border-right: none !important;
}

.mis-container .mis-table-card .mis-table thead th:first-child {
  border-top-left-radius: 3px;
}

.mis-container .mis-table-card .mis-table thead th:last-child {
  border-top-right-radius: 3px;
}

/* td colour is NOT !important so your inline blue/red colours still work */
.mis-container .mis-table-card .mis-table tbody td {
  padding: 11px 10px;
  background: var(--row) !important;
  color: #111;
  font-size: 12.5px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  border: none !important;
  border-right: 1px solid #ffffff !important;
  border-bottom: 1px solid #ffffff !important;
}

.mis-container .mis-table-card .mis-table tbody td:last-child {
  border-right: none !important;
}

.mis-container .mis-table-card .mis-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* ---------- white card: pagination / footer part ---------- */

.mis-container .mis-table-card > .mis-table-wrap + div {
  margin-top: 0 !important;
  padding: 12px 18px 14px !important;
  background: #ffffff;
  border-radius: 0 0 14px 14px;
}

.mis-container .mis-table-card > .mis-table-wrap + div > div:first-child {
  font-weight: 700;
  color: #111 !important;
  font-size: 12px !important;
}

/* =========================================================
   RESPONSIVE
========================================================= */

@media (max-width: 1199px) {
  .mis-filter-section {
    padding: 14px 16px;
  }
  .mis-filter-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 16px;
  }
  .mis-card-wrapper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
  .mis-card-wrapper:has(.mis-card:nth-child(9)) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-width: 100%;
  }
}

@media (max-width: 767px) {
  .mis-filter-row {
    grid-template-columns: 1fr;
  }
  .mis-card-wrapper,
  .mis-card-wrapper:has(.mis-card:nth-child(9)) {
    grid-template-columns: 1fr;
    padding: 14px;
  }
  .mis-card {
    height: 130px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/MIS/MisReports/MisReport.css"],"names":[],"mappings":"AAAA;;2DAE2D;;AAE3D;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;2DAE2D;;AAE3D;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB;;;;;;GAMC;AACH;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;;;2DAI2D;;AAE3D;EACE,WAAW;EACX,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;IACjB,wCAAwC;;EAE1C,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;;EAEb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,+BAA+B;EAC/B,iCAAiC;EACjC,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D;uCACqC;AACvC;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAE1B,0EAAkQ;AACpQ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB;;;;;;GAMC;AACH;;AAEA,yBAAyB,YAAY,EAAE,YAAY,EAAE,aAAa,EAAE;AACpE,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACtD,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACtD,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACtD,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACtD,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACtD,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACtD,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACtD,yBAAyB,YAAY,EAAE,aAAa,EAAE;;AAEtD;;;;;2DAK2D;;AAE3D;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;;EAEf,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kEAAkE;;AAElE;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,6CAA6C;EAC7C,0BAA0B;EAC1B,aAAa;AACf;;AAEA,iDAAiD;;AAEjD;EACE,SAAS;EACT,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,iEAAiE;AACjE;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,4DAA4D;AAC9D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+DAA+D;;AAE/D;EACE,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;2DAE2D;;AAE3D;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gDAAgD;IAChD,cAAc;EAChB;EACA;IACE,gDAAgD;IAChD,SAAS;EACX;EACA;IACE,gDAAgD;IAChD,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;;IAEE,0BAA0B;IAC1B,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* =========================================================\r\n   MIS REPORT\r\n========================================================= */\r\n\r\n.mis-container {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.mis-heading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 0 0 14px 0;\r\n  font-size: 14px;\r\n  font-weight: 800;\r\n  color: #151515;\r\n}\r\n\r\n/* =========================================================\r\n   FILTER BAR (dark blue, white labels, white rounded selects)\r\n========================================================= */\r\n\r\n.mis-filter-section {\r\n  width: 100%;\r\n  min-height: 86px;\r\n  margin: 0 0 0px 0;\r\n  padding: 0 24px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  border: none;\r\n  border-radius: 0;\r\n  overflow: visible;\r\n  background: linear-gradient(\r\n    180deg,\r\n    #005394 0%,\r\n    #00579a 50%,\r\n    #0a67b0 80%,\r\n    #1a7fcb 100%\r\n  );\r\n}\r\n\r\n.mis-filter-row {\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.mis-filter-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.mis-filter-group label {\r\n  flex: 0 0 auto;\r\n  margin: 0;\r\n  white-space: nowrap;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n}\r\n\r\n/* react-select wrapper takes the remaining width */\r\n.mis-filter-group > div {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.mis-select__control {\r\n  min-height: 38px !important;\r\n  height: 38px !important;\r\n  border: 1px solid #d9e6f4 !important;\r\n  border-radius: 10px !important;\r\n  background: #fff !important;\r\n  box-shadow: none !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.mis-select__control--is-focused {\r\n  border-color: #7fb8f0 !important;\r\n  box-shadow: 0 0 0 2px rgba(127, 184, 240, 0.45) !important;\r\n}\r\n\r\n.mis-select__value-container {\r\n  padding: 0 10px !important;\r\n  flex-wrap: nowrap !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.mis-select__placeholder,\r\n.mis-select__single-value {\r\n  font-size: 11px !important;\r\n  color: #222 !important;\r\n  white-space: nowrap !important;\r\n  overflow: hidden !important;\r\n  text-overflow: ellipsis !important;\r\n}\r\n\r\n.mis-select__input-container {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.mis-select__indicators {\r\n  height: 36px !important;\r\n}\r\n\r\n.mis-select__indicator {\r\n  padding: 6px !important;\r\n  color: #111 !important;\r\n}\r\n\r\n.mis-select__indicator-separator {\r\n  display: none !important;\r\n}\r\n\r\n.mis-select__menu {\r\n  z-index: 20 !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n/* =========================================================\r\n   CARDS  (works with the ORIGINAL markup:\r\n   .mis-card > .mis-card-icon + .mis-card-content + .metric-arrow)\r\n   Default 8 cards: 4 columns. 9 cards (Budget): centered 3 columns.\r\n========================================================= */\r\n\r\n.mis-card-wrapper {\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 20px;\r\n  margin: 0;\r\n  padding: 20px;\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, .12);\r\n\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Budget has 9 cards -> 3 columns, centered (no JSX change needed) */\r\n.mis-card-wrapper:has(.mis-card:nth-child(9)) {\r\n  grid-template-columns: repeat(3, 223px);\r\n  justify-content: center;\r\n}\r\n\r\n.mis-card {\r\n  --c: #1f5fae;\r\n  --v: var(--c);\r\n  --bg: #f1f4f9;\r\n\r\n  min-width: 0;\r\n  height: 135px;\r\n  padding: 14px 20px 14px;\r\n  box-sizing: border-box;\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  grid-template-rows: auto 1fr auto;\r\n  background: var(--bg);\r\n  border: 1px solid var(--c);\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.mis-card-icon {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n  width: 42px;\r\n  height: 42px;\r\n  color: var(--c);\r\n  margin: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.mis-card-icon img {\r\n  width: 42px;\r\n  height: 42px;\r\n  object-fit: contain;\r\n  /* bolder look: stronger colour + slight outline thickening */\r\n  filter: saturate(1.5) contrast(1.25) brightness(0.92)\r\n    drop-shadow(0 0 0.6px currentColor);\r\n}\r\n\r\n/* arrow: image hidden, circle + arrow drawn in the card colour */\r\n.mis-card .metric-arrow {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  align-self: start;\r\n  position: relative;\r\n  width: 22px;\r\n  height: 22px;\r\n  margin: 0;\r\n  box-sizing: border-box;\r\n  background: #ffffff;\r\n  border: 1.5px solid var(--c);\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n}\r\n\r\n.mis-card .metric-arrow-img {\r\n  display: none;\r\n}\r\n\r\n.mis-card .metric-arrow::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background-color: var(--c);\r\n  -webkit-mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='3.6' stroke-linecap='round' stroke-linejoin='round'><path d='M5 12h14M13 6l6 6-6 6'/></svg>\") center / 11px 11px no-repeat;\r\n  mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='3.6' stroke-linecap='round' stroke-linejoin='round'><path d='M5 12h14M13 6l6 6-6 6'/></svg>\") center / 11px 11px no-repeat;\r\n}\r\n\r\n.mis-card-content {\r\n  grid-column: 1 / -1;\r\n  grid-row: 2;\r\n  align-self: end;\r\n  min-width: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.mis-card-content h6 {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  line-height: 1.25;\r\n  color: #111;\r\n}\r\n\r\n.mis-card-content h3 {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n  color: var(--v);\r\n}\r\n\r\n/* progress-style bar at the bottom */\r\n.mis-card::after {\r\n  content: \"\";\r\n  grid-column: 1 / -1;\r\n  grid-row: 3;\r\n  height: 4px;\r\n  margin-top: 8px;\r\n  border-radius: 2px;\r\n  background: linear-gradient(\r\n    to right,\r\n    var(--c) 0,\r\n    var(--c) 76%,\r\n    #c4c4c4 76%,\r\n    #c4c4c4 100%\r\n  );\r\n}\r\n\r\n.mis-card:nth-child(1) { --c: #1f5fae; --v: #3b8fd9; --bg: #f1f4f9; }\r\n.mis-card:nth-child(2) { --c: #7b3f9e; --bg: #f7f2fa; }\r\n.mis-card:nth-child(3) { --c: #c8203c; --bg: #f8e6e9; }\r\n.mis-card:nth-child(4) { --c: #d4731f; --bg: #fcf9f0; }\r\n.mis-card:nth-child(5) { --c: #0f9e8c; --bg: #edfcff; }\r\n.mis-card:nth-child(6) { --c: #2b3a94; --bg: #e6ebfa; }\r\n.mis-card:nth-child(7) { --c: #1f8a5a; --bg: #e9f6ef; }\r\n.mis-card:nth-child(8) { --c: #6b4423; --bg: #fcf5ee; }\r\n.mis-card:nth-child(9) { --c: #c0397a; --bg: #fdeef5; }\r\n\r\n/* =========================================================\r\n   DETAIL TABLE SCREENS (all tables share this look)\r\n   faint panel  >  header row  >  white card (table + pagination)\r\n   Selectors are scoped under .mis-container so they beat innercss.css\r\n   regardless of import order.\r\n========================================================= */\r\n\r\n.mis-container .mis-table-card {\r\n  --panel: #edf0f6;\r\n  --th: #2f7bd9;\r\n  --row: #e6f1fb;\r\n  --line: #b9d6f2;\r\n\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  background: var(--panel) !important;\r\n  border-radius: 14px;\r\n  padding: 14px 14px 16px;\r\n}\r\n\r\n/* ---------- header row (back button, title, search) ---------- */\r\n\r\n.mis-container .mis-table-card > div:first-child {\r\n  margin-bottom: 14px !important;\r\n}\r\n\r\n.mis-container .mis-table-card > div:first-child button {\r\n  width: 36px;\r\n  height: 36px;\r\n  padding: 0 !important;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #ffffff !important;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 4px rgba(20, 40, 100, 0.12);\r\n}\r\n\r\n.mis-container .mis-table-card > div:first-child button img {\r\n  width: 26px !important;\r\n  height: 26px !important;\r\n  object-fit: contain;\r\n}\r\n\r\n.mis-container .mis-table-card h4 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #111;\r\n}\r\n\r\n.mis-container .mis-table-card input[type=\"text\"] {\r\n  height: 36px !important;\r\n  background: #ffffff !important;\r\n  border: 1px solid #dbe3ef !important;\r\n  border-radius: 10px !important;\r\n  box-shadow: 0 1px 3px rgba(20, 40, 100, 0.06);\r\n  font-size: 12px !important;\r\n  outline: none;\r\n}\r\n\r\n/* ---------- white card: table part ---------- */\r\n\r\n.mis-container .mis-table-card > .mis-table-wrap {\r\n  margin: 0;\r\n  padding: 14px 14px 0;\r\n  background: #ffffff !important;\r\n  border-radius: 4px 4px 0 0;\r\n  overflow-x: auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table {\r\n  width: 100%;\r\n  border-collapse: separate !important;\r\n  border-spacing: 0 !important;\r\n  table-layout: auto;\r\n  border: 1px solid var(--line) !important;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  background: var(--row) !important;\r\n}\r\n\r\n/* neutralise global tr / thead / tbody rules from innercss.css */\r\n.mis-container .mis-table-card .mis-table tr {\r\n  border: none !important;\r\n  font-size: inherit !important;\r\n  background: transparent;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table thead,\r\n.mis-container .mis-table-card .mis-table tbody {\r\n  text-align: center;\r\n  border: none !important;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table thead th {\r\n  padding: 11px 10px;\r\n  background: var(--th) !important;\r\n  color: #ffffff !important;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  border: none !important;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.55) !important;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table thead th:last-child {\r\n  border-right: none !important;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table thead th:first-child {\r\n  border-top-left-radius: 3px;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table thead th:last-child {\r\n  border-top-right-radius: 3px;\r\n}\r\n\r\n/* td colour is NOT !important so your inline blue/red colours still work */\r\n.mis-container .mis-table-card .mis-table tbody td {\r\n  padding: 11px 10px;\r\n  background: var(--row) !important;\r\n  color: #111;\r\n  font-size: 12.5px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n  border: none !important;\r\n  border-right: 1px solid #ffffff !important;\r\n  border-bottom: 1px solid #ffffff !important;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table tbody td:last-child {\r\n  border-right: none !important;\r\n}\r\n\r\n.mis-container .mis-table-card .mis-table tbody tr:last-child td {\r\n  border-bottom: none !important;\r\n}\r\n\r\n/* ---------- white card: pagination / footer part ---------- */\r\n\r\n.mis-container .mis-table-card > .mis-table-wrap + div {\r\n  margin-top: 0 !important;\r\n  padding: 12px 18px 14px !important;\r\n  background: #ffffff;\r\n  border-radius: 0 0 14px 14px;\r\n}\r\n\r\n.mis-container .mis-table-card > .mis-table-wrap + div > div:first-child {\r\n  font-weight: 700;\r\n  color: #111 !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n/* =========================================================\r\n   RESPONSIVE\r\n========================================================= */\r\n\r\n@media (max-width: 1199px) {\r\n  .mis-filter-section {\r\n    padding: 14px 16px;\r\n  }\r\n  .mis-filter-row {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 12px 16px;\r\n  }\r\n  .mis-card-wrapper {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 16px;\r\n  }\r\n  .mis-card-wrapper:has(.mis-card:nth-child(9)) {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .mis-filter-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .mis-card-wrapper,\r\n  .mis-card-wrapper:has(.mis-card:nth-child(9)) {\r\n    grid-template-columns: 1fr;\r\n    padding: 14px;\r\n  }\r\n  .mis-card {\r\n    height: 130px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
